module.exports = __webpack_public_path__ + "img/iconPhoneGreen.20e67b7c.svg";